import * as React from "react"
import { Box, Chip } from "@mui/material"

import { boxChipBlock } from "./styles"


export default function ChipBlock({ listElements, ...props }) {
	return <Box sx={{ ...boxChipBlock, ...props?.sx }}>
		<Box>
            { listElements?.length > 0 && listElements.map((item, idx) => 
                <Chip 
                    label={item} 
                    key={idx} 
                    sx={{ mr: 1, mt: 1, backgroundColor: "disabled.dark" }} 
                />
            )}
        </Box>
	</Box>
}